import { Component } from '@angular/core';

import { PcBasedSimulatorComponent } from '../../../common/pc-based-simulator/pc-based-simulator.component';
import { SimulatorConfig } from '../../../core/models/simulation.model';
import { SimulatorType } from '../../../core/enums/simulator-type.enum';

@Component({
  selector: 'app-saturation-exponent',
  imports: [PcBasedSimulatorComponent],
  templateUrl: './saturation-exponent.component.html',
  styleUrl: './saturation-exponent.component.scss',
  standalone: true,
})
export class SaturationExponentComponent {
  readonly config: SimulatorConfig = {
    title: 'Subsample - Saturation Exponent Simulation',
    simulatorType: SimulatorType.SubsampleN,
  };
}
